import type { TmTooltipDirectiveData } from '@/components/shared/tooltip/types'
import { ref, shallowReadonly } from '@/composition/vue/compositionApi'
import { getUuid } from '@/utils/uuid'

type Tooltip = {
  id: string
  anchorElement: HTMLElement
  tooltipData: TmTooltipDirectiveData
}

const _tooltips = ref<Tooltip[]>([])

export function useTooltipManager() {
  const registerTooltip = (anchorElement: HTMLElement, tooltipData: TmTooltipDirectiveData) => {
    _tooltips.value.push({
      id: getUuid(), // just used as key in v-for loop
      anchorElement,
      tooltipData,
    })
  }

  const unregisterTooltip = (anchorElement: HTMLElement) => {
    _tooltips.value = _tooltips.value.filter((tooltip) => tooltip.anchorElement !== anchorElement)
  }

  const isRegisteredTooltip = (anchorElement: HTMLElement) => {
    return _tooltips.value.find((tooltip) => tooltip.anchorElement === anchorElement)
  }

  const updateTooltipData = (anchorElement: HTMLElement, tooltipData: TmTooltipDirectiveData) => {
    const tooltip = _tooltips.value.find((t) => t.anchorElement === anchorElement)
    if (tooltip) {
      tooltip.tooltipData = tooltipData
    }
  }

  return {
    tooltips: shallowReadonly(_tooltips),
    registerTooltip,
    unregisterTooltip,
    isRegisteredTooltip,
    updateTooltipData,
  }
}
